/**
 * Converts a base64 string to an image source URL. Mostly used for profile avatars
 *
 * @param {string} [base64=''] - The base64 string to convert. Defaults to an empty string.
 * @returns {string} The image source URL in the format `data:image/png;base64,<base64>`.
 */
export const base64ToImageSource = (base64 = '') => {
    return `data:image/png;base64,${base64}`;
};
